<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import type { ItemProps } from './belowCtaListItem.svelte';

	interface Props {
		content: ISbStoryData<{
			items: Array<ISbStoryData<ItemProps>['content']>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<ul class="flex justify-center gap-x-1 text-[14px]/[160%] text-brown-1">
	{#each content.items as item}
		<Blok content={item} />
	{/each}
</ul>

<style>
	ul {
		:global(li) {
			&:not(:last-child)::after {
				content: '·';
				margin-left: theme('spacing.1');
			}
		}
	}
</style>
